import Axios from "axios"
import WeditApi from "../../common/WeditApi"
import SettingsModel from "../model/SettingsModel"
import {retry} from "../../common/Retry"

class SettingsApi {
  public static URL = `${WeditApi.URL}/settings`

  public static async getSettings(): Promise<SettingsModel> {
    return retry(async () => {
      const x = await Axios.get(`${this.URL}/${WeditApi.CLIENT_UUID}`, {timeout: 5000})
      return x.data
    })
  }
}

export default SettingsApi
